import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { Paginated } from './paginated';
import type { PortalAssetData } from '@/types/api';

type AssetFilters = {
  q?: string;
  type?: string;
  status?: string;
  page?: number;
};

/** Read-only asset list for the portal, scoped + feature-gated server-side. */
export function usePortalAssets(filters: AssetFilters = {}) {
  return useQuery({
    queryKey: ['portal-assets', filters],
    queryFn: async (): Promise<Paginated<PortalAssetData>> => {
      const { data } = await api.get<Paginated<PortalAssetData>>('/v1/portal/assets', {
        params: filters,
      });
      return data;
    },
  });
}
